<template>
  <div>
    <button
      type="button"
      class="button is-outlined is-danger is-medium is-fullwidth"
      @click="toggle"
    >
      <i class="fa fa-file-o" /> &nbsp;&nbsp;
      {{ $t('employee-group.create-and-add') }}
    </button>

    <div :class="show ? 'is-active' : ''" class="modal">
      <div class="modal-background" @click="toggle" />
      <div class="modal-card">
        <header class="modal-card-head">
          <p
            class="modal-card-title"
            v-text="$t('employee-group.create-and-add')"
          />
          <button class="delete" aria-label="close" @click="toggle" />
        </header>
        <section class="modal-card-body">
          <div class="field">
            <p class="control has-icon  has-icons-left has-icon-right">
              <input
                id="name"
                v-model="newEmployee.name"
                :placeholder="$t('employee-group.list.name')"
                :class="newEmployee.errors.has('name') ? 'is-danger' : ''"
                class="input is-medium"
                type="text"
                name="name"
              />
              <span class="icon is-small is-left">
                <i class="fa fa-user" />
              </span>
              <span v-if="newEmployee.errors.has('name')" class="icon is-small">
                <i class="fa fa-warning" />
              </span>
            </p>
            <p
              v-if="newEmployee.errors.has('name')"
              class="help is-danger"
              v-html="newEmployee.errors.get('name')"
            />
          </div>
          <div class="field">
            <p class="control has-icon has-icons-left has-icon-right">
              <input
                id="email"
                v-model="newEmployee.email"
                :placeholder="$t('employee-group.list.email')"
                :class="newEmployee.errors.has('email') ? 'is-danger' : ''"
                class="input is-medium"
                type="email"
                name="email"
              />
              <span class="icon is-small is-left">
                <i class="fa fa-envelope" />
              </span>
              <span
                v-if="newEmployee.errors.has('email')"
                class="icon is-small"
              >
                <i class="fa fa-warning" />
              </span>
            </p>
            <p
              v-if="newEmployee.errors.has('email')"
              class="help is-danger"
              v-html="newEmployee.errors.get('email')"
            />
          </div>
        </section>
        <footer class="modal-card-foot">
          <div class="level is-full-width">
            <div class="level-left">
              <button
                class="button"
                @click="toggle"
                v-text="$t('employee-group.search-close-button')"
              />
            </div>
            <div class="level-right">
              <button
                class="button is-success"
                @click="create"
                v-text="$t('employee-group.search-add-button')"
              />
            </div>
          </div>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
import Form from 'helpers/Form/Form';

export default {
  name: 'CreateEmployee',

  data() {
    return {
      show: false,
      newEmployee: new Form({
        name: '',
        email: ''
      })
    };
  },

  methods: {
    toggle() {
      this.show = !this.show;
    },

    create() {
      this.newEmployee
        .post('/employees')
        .then(({ data }) => {
          VueEventHub.$emit('employee-created', data);
          this.newEmployee = new Form({
            name: '',
            email: ''
          });
        })
        .catch(() => {
          error(this.$t('employee.create-error'));
        });
    }
  }
};
</script>
